import React from 'react';
import PropTypes from 'prop-types';
import { detect } from 'detect-browser';

import Button from '../Button';
import { getAsset } from '../../../util/assets';
import getConfig from '../../../util/config';
import { isIOS } from '../../../util/device-detector';
import BrowserIcon from '../BrowserIcon';
import { getBrowserName } from './helpers';

const propTypes = {
  onDismiss: PropTypes.func.isRequired,
};

const AppDownloadBanner = ({ onDismiss }) => {
  const config = getConfig();

  const appUrl = isIOS()
    ? config.mobile.iosAppUrl
    : config.mobile.androidAppUrl;

  const browser = detect();

  return (
    <div className="app-download-banner-backdrop">
      <div className="app-download-banner">
        <p className="mb-0 text-extra-bold text-dark text-center mb-0 h4">
          View in...
        </p>
        <hr className="my-2" />

        <div className="d-flex align-items-center mb-2">
          <div className="app-download-icon-container">
            <img
              className="app-download-icon"
              src={getAsset('/waldo-icon.svg')}
              alt=""
            />
          </div>
          <p className="text-bold mb-0 text-dark my-2 ml-1">Waldo Photos App</p>
          <Button className="app-download-btn" href={appUrl}>
            Open
          </Button>
        </div>
        <div className="d-flex align-items-center mb-2">
          <div className="app-download-icon-container">
            <BrowserIcon
              className="app-download-icon"
              browser={browser?.name}
            />
          </div>
          <p className="text-bold mb-0 text-dark my-2 ml-1">
            {getBrowserName(browser?.name)}
          </p>
          <Button
            className="browser-download-btn"
            btnOutline
            onClick={onDismiss}
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};

AppDownloadBanner.propTypes = propTypes;

export default AppDownloadBanner;
